import { z } from 'zod';
import { RunPodCloudSchema } from './runpod.js';
/** Pods Couch creates (doc 58). The volume holds Couch and the models; it survives a stop. */
export const POD_VOLUME_GB = Object.freeze({ min: 20, max: 500, default: 50 });
export const DEFAULT_POD_GPU = 'NVIDIA L4';
/** A pod without a volume (doc 72): a bigger container disk, nothing kept when it stops. */
export const POD_NO_VOLUME_DISK_GB = 80;
export const CreateRunPodPodRequestSchema = z.object({
    gpuTypeId: z.string().min(1).max(100),
    cloud: RunPodCloudSchema,
    /** 0 = no volume (doc 72). */
    volumeGb: z.union([z.literal(0), z.number().int().min(POD_VOLUME_GB.min).max(POD_VOLUME_GB.max)]).default(POD_VOLUME_GB.default),
    name: z.string().trim().min(1).max(60).regex(/^[\p{L}\p{N} ._()-]+$/u, 'Letters, digits, spaces and . _ - ( ) only').optional(),
    /** The cost warning (doc 51) — the user has to tick it. */
    acknowledged: z.literal(true),
});
/**
 * creating = Google is still being asked for a VM (doc 70); failed = no VM came of it (`error` says why);
 * installing = waiting for the machine to pair; paired = it is a machine now; expired = it never paired in time.
 */
export const CloudPodStateSchema = z.enum(['creating', 'failed', 'installing', 'paired', 'expired']);
/** RunPod's Secure/Community cloud, or a Google VM's provisioning model (doc 70). */
export const CloudPodCloudSchema = z.union([RunPodCloudSchema, z.enum(['spot', 'standard'])]);
/** A machine Couch made at a provider: a RunPod pod (`podId`) or a Google VM (`podId` = instance name, zone). */
export const CloudPodSchema = z.object({
    id: z.string(),
    provider: z.enum(['runpod', 'gcp']),
    podId: z.string(),
    name: z.string(),
    gpuName: z.string(),
    cloud: CloudPodCloudSchema,
    /** RunPod: the datacenters; Google: the zone (empty while Couch is still looking for one). */
    dataCenterIds: z.array(z.string()),
    /** RunPod's price; null for Google (its price list applies). */
    pricePerHour: z.number().nullable(),
    volumeGb: z.number().int(),
    createdAt: z.string(),
    state: CloudPodStateSchema,
    machineId: z.string().nullable(),
    consoleUrl: z.string(),
    /** Why a Google VM could not be created (state failed). */
    error: z.string().nullable().default(null),
});
export const CloudPodResponseSchema = z.object({ pod: CloudPodSchema, via: z.string() });
export const CloudPodsResponseSchema = z.object({ pods: z.array(CloudPodSchema) });
/** What RunPod says about a pod right now (doc 59): PROVISIONING, STARTING, RUNNING, EXITED (stopped), ERROR, TERMINATED. */
export const CloudPodLiveSchema = z.object({
    status: z.string(),
    costPerHour: z.number(),
    actions: z.array(z.string()),
    startedAt: z.string().nullable(),
});
export const CloudPodLiveResponseSchema = z.object({ live: CloudPodLiveSchema });
/** RunPod's console page of one pod. */
export function runpodPodConsoleUrl(podId) {
    return `https://console.runpod.io/pods?id=${encodeURIComponent(podId)}`;
}
//# sourceMappingURL=cloud-pods.js.map